import { env } from "@/env"
import { configureStore } from "@reduxjs/toolkit"
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist"
import { encryptTransform } from "redux-persist-transform-encrypt"

import { baseApi } from "./base-api"
import authReducer from "./features/auth/authSlice"
import basketReducer from "./features/menu/basket/basketSlice"
import checkoutReducer from "./features/menu/checkout/checkoutSlice"
import { storage } from "./storage"

const encryptor = encryptTransform({
  secretKey: env.NEXT_PUBLIC_STORE_ENCRYPT_SECRET_KEY,
  onError: function (error) {},
})

const createPersistConfig = (key: string) => {
  const persistConfig = {
    key,
    storage,
    transforms: [encryptor],
  }
  return persistConfig
}

const persistedAuthReducer = persistReducer(
  createPersistConfig("_auth"),
  authReducer
)
const persistedBasketReducer = persistReducer(
  createPersistConfig("_basket"),
  basketReducer
)

export const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    basket: persistedBasketReducer,
    checkout: checkoutReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(baseApi.middleware),
})

export const persistor = persistStore(store)
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
